import { reactive } from 'vue';

// Status of the loads the layout runs for every page (site settings, mods, the matchmaking
// party, the running-server check), so a page reading the store can tell "still loading" from
// "failed" and offer a retry. Module scope like the store: the layout remounts on every route.
// 'idle' (not started, or not allowed), 'loading', 'ready', 'error'.
const status = reactive({
  settings: 'idle', mods: 'idle', party: 'idle', servers: 'idle',
});
const loaders = {};
const latest = {};

// Runs `load` (a function returning a promise) and records how it went. Only the newest call
// for a name writes its status, so a late answer from a page already left cannot override it.
// A refresh that fails after an earlier success keeps 'ready': the store still holds that data.
export function trackSharedLoad(name, load) {
  loaders[name] = load;
  latest[name] = (latest[name] || 0) + 1;
  const mine = latest[name];
  if (status[name] !== 'ready') status[name] = 'loading';
  return new Promise((resolve) => { resolve(load()); })
    .then(() => { if (mine === latest[name]) status[name] = 'ready'; })
    .catch(() => { if (mine === latest[name] && status[name] !== 'ready') status[name] = 'error'; });
}

export function retrySharedLoad(name) {
  return loaders[name] ? trackSharedLoad(name, loaders[name]) : Promise.resolve();
}

// For tests: back to a fresh page load
export function resetSharedLoads() {
  Object.keys(status).forEach((k) => { status[k] = 'idle'; delete loaders[k]; });
}

export default function useSharedLoads() {
  return { status, retry: retrySharedLoad };
}
